export const ABONEMENT_CONTRACT_MODEL = 'abonament';
export const PREPAID_CONTRACT_MODEL = 'prepaid';

export const MOBILE_CONTRACT_MODELS = {
  abonament: ABONEMENT_CONTRACT_MODEL,
  prepaid: PREPAID_CONTRACT_MODEL,
};

export const MOBILE_CONTRACT_ID_MAP = {
  [MOBILE_CONTRACT_MODELS.abonament]: 2,
  [MOBILE_CONTRACT_MODELS.prepaid]: 1,
};
